import AddChild from './AddChild.vue';
import genderLibrary from './genderLibrary';

export { genderLibrary };
export * from './types';
export default AddChild;



// WEBPACK FOOTER //
// ./src/pages/profile/blocks/children/sidebar/components/addchildform/index.ts